import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Search, User, Briefcase } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const MobileBottomNav: React.FC = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) return null;

  const hideOnPaths = ['/login', '/signup', '/forgot-password', '/verify-email'];
  if (hideOnPaths.some((p) => location.pathname.startsWith(p))) return null;

  const items = [
    { to: '/task-dashboard', label: 'Hub', icon: LayoutDashboard },
    { to: '/my-workspace', label: 'My Work', icon: Briefcase },
    { to: '/marketplace', label: 'Explore', icon: Search },
    { to: '/profile-settings', label: 'Profile', icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-tech-border/40 bg-tech-dark/95 backdrop-blur-xl lg:hidden safe-area-bottom">
      <div className="flex items-stretch">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to || location.pathname.startsWith(item.to + '/');
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors ${
                isActive
                  ? 'text-tech-cyan'
                  : 'text-tech-text-muted'
              }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'drop-shadow-[0_0_6px_rgba(34,211,238,0.5)]' : ''}`} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
